import React from 'react';
import { CaseStatusData } from '../types/CaseStatusData';
import { PaymentProvider } from '../types/PaymentTypes';
import PaymentReceivedCard from './PaymentReceivedCard';
import PaymentInfoCard from './PaymentInfoCard';

type Props = {
  data: CaseStatusData;
  payWithoutLoginEnabled: boolean;
  providers: PaymentProvider[];
  providersLoading: boolean;
  confirmLoading: boolean;
  onPickProvider: () => void;
  onConfirmProvider: (provider: PaymentProvider) => void;
};

const PaymentAllocatedCard = ({
  data,
  payWithoutLoginEnabled,
  providers,
  providersLoading,
  confirmLoading,
  onPickProvider,
  onConfirmProvider,
}: Props) => {
  const [detailsExpanded, setDetailsExpanded] = React.useState(false);

  return (
    <PaymentReceivedCard
      data={data}
      detailsExpanded={detailsExpanded}
      onToggleDetails={() => setDetailsExpanded((prev) => !prev)}
    >
      <PaymentInfoCard
        data={data}
        payWithoutLoginEnabled={payWithoutLoginEnabled}
        providers={providers}
        providersLoading={providersLoading}
        confirmLoading={confirmLoading}
        onPickProvider={onPickProvider}
        onConfirmProvider={onConfirmProvider}
        hideRemainingAmount
        hidePayNow
        embedded
      />
    </PaymentReceivedCard>
  );
};

export default PaymentAllocatedCard;

